import { TLoginRequest } from "@/features/auth/types/loginRequest";
import { TLoginResponse } from "@/features/auth/types/loginResponse";
import { clientApi } from "@/utils/api";
import { logout } from "@/utils/logout";
import { setToken } from "@/utils/token";
import { ADMIN_EMAIL_KEY } from "@/utils/constants";
import { TApiRes } from "@/types/api";

import Cookies from "js-cookie";

export const loginApi = async (payload: TLoginRequest): Promise<TLoginResponse> => {
  try {
    const {
      data: { data },
    } = await clientApi.post<TApiRes<TLoginResponse>>("/login", payload);

    // Await the revoke+clear of the previous session before writing the new
    // tokens, otherwise logout() would wipe the session it just replaced.
    await logout();
    setToken(data.accessToken, data.refreshToken);
    Cookies.set(ADMIN_EMAIL_KEY, data.email);
    return data;
  } catch (error) {
    return Promise.reject(error);
  }
};
